import { toast } from 'react-toastify';

import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
} from './actions';

export function* requestEstoquePostos({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'estoquespostoscomboios', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* deleteEstoquePosto({ payload }) {
  try {
    const { id, params } = payload;

    yield call(api.delete, `estoquespostoscomboios/${id}`);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* store({ payload }) {
  try {
    const { data, params } = payload;

    yield call(api.post, 'estoquespostoscomboios', data);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    history.push('/estoqueposto');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* find({ payload }) {
  try {
    const { id } = payload;

    const { data } = yield call(api.get, `estoquespostoscomboios/${id}`);
    yield put(successRequest(data));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* update({ payload }) {
  try {
    const { data, params } = payload;

    yield call(api.put, 'estoquespostoscomboios', data);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/estoqueposto');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;

    const response = yield call(api.get, 'estoquespostoscomboios', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export default all([
  takeLatest(
    '@operacaoestoqueposto/ESTOQUEPOSTOS_IN_REQUEST',
    requestEstoquePostos
  ),
  takeLatest('@operacaoestoqueposto/DELETE_ESTOQUEPOSTO', deleteEstoquePosto),
  takeLatest('@operacaoestoqueposto/SUCCESS_REMOVE', requestEstoquePostos),
  takeLatest('@operacaoestoqueposto/STORE_ESTOQUEPOSTO', store),
  takeLatest('@operacaoestoqueposto/FIND_ESTOQUEPOSTO', find),
  takeLatest('@operacaoestoqueposto/UPDATE_ESTOQUEPOSTO', update),
  takeLatest('@operacaoestoqueposto/RECORD_FILTERING', applyedFilters),
  takeLatest('@operacaoestoqueposto/RESET_FILTERING', applyedFilters),
]);
